import React from 'react';

const ChannelHeader = () => {
  return (
    <div className="flex flex-col gap-1 w-full">
      <h1 className="text-headline3 font-nunito font-bold text-secondary-90">
        Channel Integration
      </h1>
      <p className="text-body2 font-ptsans pl-1 text-secondary/60 w-[90%] md:w-[43%]">
        Seamlessly connect your e-commerce stores for automated orders,
        real-time tracking, and efficient logistics.
      </p>
    </div>
  );
};

export default ChannelHeader;